import {
    course_copyCourse_Api,
    course_deleteCourseEnrollment_Api,
    course_editCourse_Api,
    course_manageCourseEnrollmentAccept_Api,
    course_manageCourseEnrollmentReject_Api,
    course_registerForCourse_Api,
} from 'apis'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import {useState} from 'react'
import {NullAsDefault} from 'views/Shared'
import {notifyOnError} from '../factory/createErrorEvent'
import {NotificationActionTypes, successNotify,} from '../factory/createNotification'

export const useCourse = ({
                              onUpdated = NullAsDefault,
                              onDuplicated = NullAsDefault,
                              onApproved = NullAsDefault,
                              onRejected = NullAsDefault,
                              onRegistered = NullAsDefault,
                              onEnrollmentDeleted = NullAsDefault,
                          }) => {
    const t = useTranslate()

    const [refreshKey, setRefreshKey] = useState()

    const onRefresh = () => {
        setRefreshKey(Date.now())
    }

    const onError = notifyOnError(t)

    const updateAsync = useAsyncAction({
        onError,
        apiInfo: course_editCourse_Api,
        onSuccess: (...args) => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onUpdated(...args)
        },
    })

    const {handleAsyncAction: onUpdate} = updateAsync || {};

    const {handleAsyncAction: onDuplicate} = useAsyncAction({
        onError,
        apiInfo: course_copyCourse_Api,
        onSuccess: (...args) => {
            successNotify(NotificationActionTypes.CREATE, t)
            onDuplicated(...args)
        },
    })

    const {handleAsyncAction: onRegister} = useAsyncAction({
        onError,
        apiInfo: course_registerForCourse_Api,
        onSuccess: (...args) => {
            onRegistered(...args)
        },
    })

    const {handleAsyncAction: onApprove} = useAsyncAction({
        apiInfo: course_manageCourseEnrollmentAccept_Api,
        onError,
        onSuccess: (...args) => {
            successNotify(NotificationActionTypes.INFORMATION, t)
            onApproved(...args)
        },
    })

    const {handleAsyncAction: onReject} = useAsyncAction({
        apiInfo: course_manageCourseEnrollmentReject_Api,
        onError,
        onSuccess: (...args) => {
            successNotify(NotificationActionTypes.INFORMATION, t)
            onRejected(...args)
        },
    })

    const {handleAsyncAction: onDeleteEnrollment} = useAsyncAction({
        apiInfo: course_deleteCourseEnrollment_Api,
        onError,
        onSuccess: (...args) => {
            successNotify(NotificationActionTypes.DELETE, t)
            onRefresh()
            onEnrollmentDeleted(...args)
        },
    })

    return {
        onUpdate,
        onDuplicate,
        onReject,
        onApprove,
        onRegister,
        onRefresh,
        refreshKey,
        onDeleteEnrollment,
        updateAsync
    }
}
